import { PlanFlat } from '../../../../domain/plan/PlanFlat';
import { PlanActionType, PlanActions } from './actions';

export interface PlanState {
  plans: PlanFlat[];
  selectedDay?: Date;
}

export const getInitialState = (): PlanState => {
  return {
    plans: [],
    selectedDay: undefined,
  };
};

export const PlanReducer = (state: PlanState, action: PlanActions): PlanState => {
  switch (action.type) {
    case PlanActionType.SET_SELECTED_DAY:
      return {
        ...state,
        selectedDay: action.payload.selectedDay,
      };
    case PlanActionType.SEARCH_PLANS_SUCCESS:
      return {
        ...state,
        plans: action.payload.plans,
      };
    default:
      return state;
  }
};
